class UMCartDrawer {
    constructor() {
        this.bindEvents();
    }

    open() {
        document.body.classList.add("um-cart-open");
    }

    close() {
        document.body.classList.remove("um-cart-open");
    }

    bindEvents() {
        document.addEventListener("click", async (e) => {

            if (e.target.closest(".um-cart-link")) {
                e.preventDefault();

                await this.refresh();
                this.open();
            }

            if (
                e.target.matches(".um-cart-close") ||
                e.target.matches(".um-cart-overlay")
            ) {
                this.close();
            }

            if (
                e.target.matches(".qty-minus") ||
                e.target.matches(".qty-plus")
            ) {
                this.updateQty(
                    e.target.dataset.key,
                    e.target.dataset.qty
                );
            }

            if (e.target.matches(".remove-item")) {
                this.updateQty(
                    e.target.dataset.key,
                    0
                );
            }
        });
    }

    async updateQty(key, qty) {
        try {
            qty = parseInt(qty);

            await fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: key,
                    quantity: qty
                })
            });

            await this.refresh();

        } catch (error) {
            console.log(error);
        }
    }

    async refresh() {

    let response = await fetch(
        "/cart?section_id=um-cart-drawer"
    );

    let html = await response.text();

    let doc = new DOMParser().parseFromString(
        html,
        "text/html"
    );

    let newDrawer = doc.querySelector(
        "#shopify-section-um-cart-drawer"
    );

    let currentDrawer = document.querySelector(
        "#shopify-section-um-cart-drawer"
    );

    if (newDrawer && currentDrawer) {

        currentDrawer.innerHTML =
            newDrawer.innerHTML;

        // re-bind events after replacing HTML
        this.bindEvents();
    }
}
}

window.umDrawer = new UMCartDrawer();